export const version = "random/5.2.0";
//# sourceMappingURL=_version.js.map